import WarningCard from "../WarningCard";

type CheckboxProps = {
  inputName: string;
  label: string;
  disabled?: boolean;
  validators?: any;
  onChange?: any;
  form: any;
  checked?: boolean;
};

export function Checkbox({
  form,
  inputName,
  label,
  validators,
  disabled,
  onChange,
  checked
}: CheckboxProps) {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        value=""
        id={inputName}
        disabled={disabled}
        {...register(inputName, validators)}
        onChange={onChange}
        checked={checked}
        style={{
          backgroundImage: "none",
        }}
      />
      <label className="form-check-label" htmlFor={inputName}>
        {label}
      </label>
    </div>
  );
}
